export const submitConsultation=async payload=>{
  const response=await fetch('/api/consultation.php',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify(payload)
  });
  const result=await response.json().catch(()=>({}));
  if(!response.ok||!result.success)throw new Error(result.message||'We could not save your request. Please try again.');
  return result;
};
